"use client";

import React from "react";
import { WifiOff } from "lucide-react";

const OfflineBanner: React.FC = () => {
  return (
    <div className="fixed inset-x-0 top-0 z-[200] flex items-center justify-center gap-2 bg-gradient-to-l from-alert-warning-dark via-alert-warning-main to-secondary-main px-4 py-2 text-center text-xs font-bold text-white shadow-lg">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
      </span>
      <WifiOff size={14} />
      <span>ارتباط با اینترنت قطع شده — در حال تلاش برای اتصال مجدد...</span>
    </div>
  );
};

export default OfflineBanner;
